import { useNavigate } from 'react-router-dom';

const trackClick = (source: string) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', 'for_sale_click', { source });
  }
};

const ForSaleFooterSection = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    trackClick('footer_section');
    navigate('/for-sale');
  };

  return (
    <section
      className="relative bg-gray-950 text-white py-16 px-4 overflow-hidden"
      aria-label="Website acquisition opportunity"
    >
      {/* Background accent */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-600 via-red-500 to-red-600"></div>
        <div className="absolute -top-24 -right-24 w-72 h-72 bg-red-600/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-12 -left-12 w-64 h-64 bg-red-600/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-5xl mx-auto text-center">
        {/* Tag */}
        <div className="inline-flex items-center gap-2 bg-red-600/20 border border-red-500/30 rounded-full px-4 py-1.5 mb-6">
          <i className="ri-price-tag-3-fill text-red-400 text-sm"></i>
          <span className="text-red-300 text-xs font-semibold tracking-widest uppercase">Available for Acquisition</span>
        </div>

        <h2 className="text-3xl md:text-4xl font-black text-white mb-4 leading-tight">
          Own This Website —
          <span className="text-red-400"> Available for Acquisition</span>
        </h2>

        <p className="text-gray-300 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
          A fully built, SEO-optimized salary calculator with 200+ city pages, an admin dashboard,
          built-in monetization, and growing organic traffic. Turnkey digital asset — ready to operate from day one.
        </p>

        {/* Stats row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10 max-w-3xl mx-auto">
          {[
            { value: '200+', label: 'City Pages' },
            { value: '100%', label: 'SEO Ready' },
            { value: '$0', label: 'Dev Needed' },
            { value: '2026', label: 'Tax Data' },
          ].map((stat, i) => (
            <div key={i} className="bg-white/5 border border-white/10 rounded-xl p-4">
              <div className="text-2xl font-black text-red-400 mb-1">{stat.value}</div>
              <div className="text-gray-400 text-xs font-medium">{stat.label}</div>
            </div>
          ))}
        </div>

        <button
          onClick={handleClick}
          className="inline-flex items-center gap-3 bg-red-600 hover:bg-red-700 text-white font-bold text-base px-8 py-4 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg shadow-red-900/30 hover:shadow-red-900/50 hover:-translate-y-0.5"
        >
          <i className="ri-briefcase-4-line text-lg"></i>
          View Acquisition Details
          <i className="ri-arrow-right-line"></i>
        </button>

        <p className="text-gray-500 text-xs mt-4">Serious inquiries only — contact form on next page</p>
      </div>
    </section>
  );
};

export default ForSaleFooterSection;
